import { useRef, type RefObject } from "react";

/**
 * Keeps `ref.current` equal to `value` on every render.
 *
 * Readers run outside this render — an effect registered once, a transport
 * callback, or a stable child handler. Writing here, rather than in an effect,
 * makes the value visible before descendant effects flush.
 */
export function useLatestRef<T>(value: T): RefObject<T> {
  const ref = useRef(value);
  // oxlint-disable-next-line react/refs -- latest-value mirror; readers run outside this render
  ref.current = value;
  return ref;
}
